/* global process */

if ('serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		navigator.serviceWorker
			.register(`${process.env.PUBLIC_PATH}/service-worker.js`).then(() => {
				console.log('SW  registered!');
			}).catch(err => {
				console.error('SW registration failed: ', err);
			});
	});
}
